import { render } from "./ButtonLeft.vue?vue&type=template&id=365ae233&scoped=true"
import script from "./ButtonLeft.vue?vue&type=script&lang=js"
export * from "./ButtonLeft.vue?vue&type=script&lang=js"

import "./ButtonLeft.vue?vue&type=style&index=0&id=365ae233&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365ae233"]])

export default __exports__